<template>
    <div class="modal-prescribe">
        <div class="modal">
            <div class="modal-header">
                <div style="padding: 6px;">添加药品处方</div>
                <button type="button" class="btn-close" @click="closeSelf">关闭</button>
            </div>
            <div class="modal-body">

                <el-form :model="addForm" ref="addForm" :rules="rules">
                    <div>
                        <el-row>
                            <el-col :span="12" class="item">
                                <el-form-item label="药品处方名称" required prop='name'>
                                    <el-input v-model="addForm.name" placeholder="请输入药品处方名称"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-col :span="24" class="item">
                                <el-card class="box-card" shadow='never'>
                                    <div slot="header" class="clearfix">
                                        <span>药品添加</span>
                                        <el-button style="float: right; padding: 3px 0" type="text" @click="WaresDrugAdd">添加</el-button>
                                    </div>
                                    <template>
                                        <el-table :data="tableDrug" border style="width: 100%;" empty-text='暂未添加药品' max-height="220">
                                            <el-table-column prop="name" label="药品名称"></el-table-column>
                                            <el-table-column prop="waresDrugNumber" label="药品数量"></el-table-column>
                                            <el-table-column label="操作" width="200">
                                                <template slot-scope="scope">
                                                    <el-button type="primary" size="small" @click.native.prevent="editRow(scope.$index, tableDrug)">修改数量</el-button>
                                                    <el-button @click.native.prevent="deleteRow(scope.$index, tableDrug)" type="danger" size="small">移除</el-button>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </template>
                                </el-card>
                            </el-col>
                        </el-row>
                    </div>
                    
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('addForm')">添加</el-button>
            </div>
        </div>
        <SelectWaresDrug ref="mySelectWaresDrug" v-show="showSelectWaresDrug" v-on:close="showSelectWaresDrug=false" v-on:getTable="getTable"></SelectWaresDrug>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";
    import SelectWaresDrug from "./SelectWaresDrug";

    export default {
        name: 'Add',
        props:['inspectionItemList'],
        data() {
            return {
                dialogTableVisible:false,
                loading: false,
                showSelectWaresDrug:false,
                tableDrug:[],
                tableDrugCode:[],
                addForm:{
                    timeStr:timeStr,
                    sign:'',
                    staffCode:getStaffCode(),
                    consultationRecordCode:'',
                    name:'',
                    waresDrugCodeArr:[]
                },
                rules:{
                    name:[
                        { required: true, message: '请输入药品处方名称', trigger: 'blur' },
                    ],
                }
            }
        },
        components:{
            SelectWaresDrug
        },
        methods: {
            init(code){
                this.loading=false
                this.$refs.addForm.resetFields();
                this.addForm.consultationRecordCode=code
            },
            closeSelf() {
                this.$emit("closePrescribe");
            },
            confirm(addForm){
                this.$refs[addForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })
            },
            editRow(index,rows){
                this.$prompt('请输入此药品入库数量', '商品数量', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern:/^[1-9]\d*$/,
                    inputErrorMessage:'添加数量不能为零',
                    inputType:'number'
                }).then(({ value }) => {
                    rows[index].waresDrugNumber=value
                    this.tableDrug=rows
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });       
                });
            },
            WaresDrugAdd(){
                this.showSelectWaresDrug=true
                this.$refs.mySelectWaresDrug.init(this.tableDrugCode);
            },
            deleteRow(index, rows){
                rows.splice(index, 1);
                this.tableDrugCode.splice(index, 1)
            },
            getTable(data){
                this.tableDrug.push(data)
                this.tableDrugCode.push(data.waresDrugCode)
            },
            addSubmit(){
                if(this.tableDrug.length==0){
                    this.$message.error('请选择药品')
                    return;
                }
                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.addForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);
                this.addForm.waresDrugCodeArr=this.tableDrug
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"CureFlow/AddPrescriptionDrug",
                    data: this.addForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closePrescribe");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },


        }
    }


</script>





<style lang="scss" scoped>

    .modal-prescribe {
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        background-color: rgba(0,0,0,.3);
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 99;

        .modal {
            background-color: #fff;
            box-shadow:  0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
            overflow-x:auto;
            display: flex;
            flex-direction: column;
            border-radius: 10px;
            width: 700px;

            .modal-header {
                border-bottom: 1px solid #eee;
                color: #313131;
                justify-content: space-between;
                padding: 10px;
                display: flex;
            }
            .modal-body /deep/ .el-card__body{
                padding: 0;
            }
            .modal-body /deep/ .el-table--border{
                border: none;
            }
            .modal-body {
                position: relative;
                padding: 20px 0px;
                z-index: 99;
                height: 100%;
            }
            
            .modal-footer {
                border-top: 1px solid #eee;
                justify-content: flex-end;
                padding: 15px;
                display: flex;
            }


        }

    }


    .btn-close, .btn-confirm {
        border-radius: 8px;
        margin-left:16px;
        width:56px;
        height: 36px;
        border:none;
        cursor: pointer;
    }
    .btn-close {
        color: #313131;
        background-color:transparent;
    }



    .row{
        padding: 10px 0px;
    }
    .item{
        padding: 0px 20px;
    }
    .label{
        padding: 5px 0px;
    }


</style>
